export const shopifyAdminIdToGraphqlId = (adminId: string): string => {
  return `gid://shopify/Product/${adminId}`;
};

export const shopifyAdminIdToVariantGraphqlId = (adminId: string): string => {
  return `gid://shopify/ProductVariant/${adminId}`;
};

export const shopifyGraphqlIdToAdminId = (graphqlId: string): string => {
  const parts = graphqlId.split('/');
  return parts[parts.length - 1];
};

/** Normalises Shopify product identifiers to admin IDs for Storefront API calls. */
export const resolveShopifyAdminProductId = (
  id: string | null | undefined,
): string | null => {
  if (!id) {
    return null;
  }

  return id.startsWith('gid://') ? shopifyGraphqlIdToAdminId(id) : id;
};

export const listGraphqlIds = (productId?: ShopifyProductIdentifier[]) => {
  return (productId || []).map(({ id }) => shopifyAdminIdToGraphqlId(id));
};
